import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../services/auth-service/auth.service'
import {ActivatedRoute, Router} from '@angular/router';
import { DataServiceService } from '../../data-service.service'
import { User } from '../../../../../../Leste 3.0/models/User'
import { Subscription } from 'rxjs';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment.prod';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import {MatSnackBar} from '@angular/material/snack-bar';
declare var FB: any
@Component({
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    standalone: false
})
export class LoginCallbackComponent implements OnInit {

  private user: User

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  err: boolean = false
  err1: boolean = false
  err2: boolean = false

  wrongInfo: boolean = false;

  backgroundClass: String = "backgroundLearning"
  header
  first: boolean = true
  index: number = 1
  imageUrl: string

  hideSpinner: boolean = true;
  constructor( private authService: AuthService, private router: Router, private languageService: UserLanguageService,
              public dialog: MatDialog,
              private localStorageService: LocalStorageService,
              private snackBar: MatSnackBar,
              private route: ActivatedRoute) {
  }

  position
  ngOnInit(): void {

    this.position = "move"
    var w = window as any
    this.err = false;
    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    //document.getElementById('zmmtg-root').style.display = 'none'
    this.imageUrl = environment.loginImagePath1 || "./assets/icons/LogoLESTE.png"
    this.wrongInfo = false
    this.header = this.labels.lblLearning

    this.onSubmit()
  }
  ngOnDestroy(): void {
    this.labelsSub.unsubscribe()
    this.langSub.unsubscribe()
  }
  onSubmit() {
    let state = this.route.snapshot.queryParams['state'];
    let sessionState = this.route.snapshot.queryParams['session_state'];
    let code = this.route.snapshot.queryParams['code'];

        this.authService.loginSSO(state, sessionState, code).subscribe((response) => {
          console.log('login response:', response)
            if (response.err == "greska" || response.err == "notAccepted") {
              this.wrongInfo = true;
              console.log("ERRR 1");
              if(response.err == "notAccepted"){
                this.router.navigate(['/terms-of-use'], {queryParams: {displayButton: true}})
              }else{
                this.router.navigateByUrl('/user/dashboard')
              }
            }else {
              this.wrongInfo = false
              this.router.navigateByUrl('/user/dashboard')
              // this.router.navigateByUrl('/user/splash-screen')
            }
            this.hideSpinner = true;
          },
          (error) => {
            this.wrongInfo = true;
            console.log('login greska:', error)
            if (error.status == 403) {
              this.snackBar.open(this.labels.lblUnverifiedEmail, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000
              })
            }
            this.hideSpinner = true;
           this.router.navigateByUrl('/user/dashboard')
          })
  }

  selectLang(lang) {
    this.languageService.setLanguage(lang);
  }
}
